// src/store/modules/alert.js
const state = {
  msg: "",
  variant: "success",
  dismissCountDown: 0,
};

const mutations = {
  SET_ALERT(state, { msg, variant }) {
    state.msg = msg;
    state.variant = variant;
    state.dismissCountDown = 5;
  },
  CLEAR_ALERT(state) {
    state.dismissCountDown = 0;
  },
};

const actions = {
  success({ commit }, msg) {
    commit("SET_ALERT", { msg, variant: "success" });
  },
  error({ commit }, msg) {
    commit("SET_ALERT", { msg, variant: "danger" });
  },
  clear({ commit }) {
    commit("CLEAR_ALERT");
  },
};

const getters = {
  msg: (state) => state.msg,
  variant: (state) => state.variant,
  dismissCountDown: (state) => state.dismissCountDown,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
